<template>
    <td 
        class="fs-cell"
        :class="{
            active: activeRow==$parent.index && activeCol==index,
            abstract: abstract,
            summation: summation || calculated,
        }"
        v-on:focus="focus"
        v-on:keydown.self="handleCellKeyDown"
        v-on:click="cellClick"
        :title="message"
    >
        {{ value|formatNumber }}
        <input
            class=input
            ref=input
            type=text
            tabindex=-1
            v-on:blur=blur
            v-on:keydown.self=handleInputKeyDown
            v-model.lazy=amount
            v-if="!abstract && showInput"
        />
        <div class="hint hint-left" v-if="inactiveFsList.left.length && index===0"></div>
        <div class="hint hint-right" v-if="inactiveFsList.right.length && index===2"></div>
    </td>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import numeral from 'numeral'

export default {
    name: 'FsCell',
    props: ['node','value','index','abstract','summation','calculated','unsatisfied-messages'],
    data() {
        return {
            showInput: false,
            previousValue: null,
            directInput: false, // determine cursor behaviour, if direct input was invoked, any cursor inside input move focus to next cell (Excel like)
        }
    },
    computed: {
        amount: {
            get() {
                return this.value
            },
            set(newValue) {
                this.$emit('input', numeral(newValue).value())
                this.$store.dispatch('reCalculate', this.index)
                this.$store.dispatch('validateAssertion')
            }
        },
        ...mapState(['activeCell','activeFsCount','lang']),
        ...mapGetters(['activeRow','activeCol','schemaRows','inactiveFsList']),
        message() {
            if (this.unsatisfiedMessages.messages) {
                return this.unsatisfiedMessages.messages.filter(m => m.lang===this.lang)[0].message
            }
            return ''
        }
    },
    methods: {
        blur() {
            // this.$parent.setHighlight(false)
            // this.activeCell = []
            this.showInput = false
        },
        focus() {
            // store previous value in case we need it
            this.previousValue = this.value
            // console.log('previousValue:', this.previousValue)
            // set active cell
            console.log('FOCUS', this.$parent.index, this.index)
            // this.$store.dispatch('setActiveCell', [this.$parent.index, this.index])
        },
        cellClick() {
            this.$store.dispatch('setActiveCell', [this.$parent.index, this.index])
        },
        handleCellKeyDown(e) {
            console.log('Cell keydown:', e.key, 'Shift:', e.shiftKey)
            if (e.key==='ArrowLeft') {
                if (this.index > 0) {
                    this.$store.dispatch('setActiveCol', this.index-1)
                }
                else if (this.index===0) {
                    this.$store.dispatch('moveActiveFsWindow', 'left')
                }
            }
            else if (e.key==='ArrowRight') {
                if (this.index < this.activeFsCount - 1) {
                    this.$store.dispatch('setActiveCol', this.index+1)
                } else {
                    this.$store.dispatch('moveActiveFsWindow', 'right')
                }
            }
            else if (e.key==='ArrowDown' || (e.key==='Enter' && !e.shiftKey)) {
                e.preventDefault()
                if (this.$parent.index < this.schemaRows - 1) {
                    this.$store.dispatch('setActiveRow', this.$parent.index+1)
                }
            }
            else if (e.key==='ArrowUp' || (e.key==='Enter' && e.shiftKey)) {
                e.preventDefault()
                if (this.$parent.index > 0) { 
                    this.$store.dispatch('setActiveRow', this.$parent.index-1)
                }
            }
            else if ('-0123456789.'.split('').includes(e.key)) {
                if (!this.abstract && !this.summation && !this.calculated) {
                    this.showInput = true
                    this.directInput = true
                    // wait for input to update before focusing it
                    this.$nextTick(() => {
                        this.$refs['input'].select()
                    })
                }
            }
            else if (e.key==='F2') {
                if (!this.abstract && !this.summation && !this.calculated) {
                    this.showInput = true
                    this.directInput = false
                    // wait for input update before focusing it
                    this.$nextTick(() => {
                        this.$refs['input'].focus()
                    })
                }
            }
            else if (e.key==='Delete') {
                if (!this.abstract && !this.summation && !this.calculated) {
                    this.amount = 0
                    // this.$nextTick(() => {
                    //     this.$store.dispatch('reCalculate', this.index)
                    // })
                    // this.$store.dispatch('removeFsItem', { key: this.$parent.key, index: this.index })
                }
            }
        },
        handleInputKeyDown(e) {
            console.log('input keydown:', e.key)
            if (e.key==='Enter' && !e.shiftKey) {
                // e.preventDefault()
                if (this.$parent.index < this.schemaRows - 1) {
                    this.$store.dispatch('setActiveRow', this.$parent.index+1)
                }
            }
            else if (e.key==='Enter' && e.shiftKey) {
                // e.preventDefault()
                if (this.$parent.index > 0) { 
                    this.$store.dispatch('setActiveRow', this.$parent.index-1)
                }
            }
            else if (e.key==='Escape') {
                // set back the old value
                e.target.value = this.previousValue

                // hide input
                this.showInput = false

                // send focus back to td, otherwise
                // we'll lost navigation control 
                this.$nextTick(() => {
                    this.$el.focus()
                })
            }
            else if (e.key==='ArrowLeft' && this.directInput) {
                if (this.index > 0) {
                    this.$store.dispatch('setActiveCol', this.index - 1)
                } else {
                    // emit change
                    this.amount = e.target.value
                    // focus td
                    this.$el.focus()
                    // move window left (if applicable)
                    this.$store.dispatch('moveActiveFsWindow', 'left')
                }
            }
            else if (e.key==='ArrowRight' && this.directInput) {
                if (this.index < this.activeFsCount - 1) {
                    this.$store.dispatch('setActiveCol', this.index + 1)
                } else {
                    this.amount = e.target.value
                    this.$el.focus()
                    this.$store.dispatch('moveActiveFsWindow', 'right')
                }
            }
            else if (e.key==='ArrowUp' && this.directInput) {
                e.preventDefault()
                this.$store.dispatch('setActiveRow', this.$parent.index - 1)
            }
            else if (e.key==='ArrowDown' && this.directInput) {
                e.preventDefault()
                this.$store.dispatch('setActiveRow', this.$parent.index + 1)
            }
        }
    },
    watch: {
    },
    mounted() {
        // this is for initial focus after page reload
        if (this.$parent.index===this.activeRow && this.index===this.activeCol) {
            this.$el.focus()
        }
    },
}
</script>

<style>
td.fs-cell {
    position: relative;
    padding: 0;
    text-align: right;
    padding: 0 5px;
}
td.fs-cell:focus{
    outline: solid 4px rgba(23, 105, 23, 0.75);
    z-index: 1;
}
td.active {
    outline: solid 4px rgba(23, 105, 23, 0.45);
    z-index: 1;
}
.input {
    position: absolute;
    border: none;
    outline: none;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
}
.abstract {
    background: #eee;
}
.summation {
    background: lightblue;
}
.hint {
    position: absolute;
    top: 0;
    width: 18px;
    height: 100%;
}
.hint-left {
    left: 0;
    background: linear-gradient(90deg, rgba(150, 150, 150, 0.25), transparent 50%);
}

.hint-right {
    right: 0;
    background: linear-gradient(270deg, rgba(150, 150, 150, 0.25), transparent 50%);
}
</style>